import React from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  withStyles,
  TableRow,
  Typography,
} from "@material-ui/core";
import { HiOutlineCheckCircle } from "react-icons/hi";
import LinearProgress from "@material-ui/core/LinearProgress";
import { AiOutlineCloseCircle } from "react-icons/ai";

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 4,
    borderRadius: 5,
  },
  colorPrimary: {
    background: " rgba(255, 255, 255, 0.04)",
  },
  bar: {
    borderRadius: 5,
    background:
      "linear-gradient(88.66deg, #FFB000 -23.01%, #FF564D 42.36%, #FF0098 107.77%);",
  },
}))(LinearProgress);

const TableData = [
  {
    token: "Decentralised",
    money: "1 ETH",
    data: "25/06/2022 8:00am",
  },
  {
    token: "Scalability",
    money: "1 ETH",
    data: "25/06/2022 8:00am",
  },
  {
    token: "Secure",
    money: "1 ETH",
    data: "25/06/2022 8:00am",
  },
  {
    token: "Speed",
    money: "1 ETH",
    data: "25/06/2022 8:00am",
  },
  {
    token: "Transaction fees",
    money: "1 ETH",
    data: "25/06/2022 8:00am",
  },
  {
    token: "Storage",
    money: "1 ETH",
    data: "25/06/2022 8:00am",
  },
  {
    token: "Consensus",
    money: "1 ETH",
    data: "25/06/2022 8:00am",
  },
  {
    token: "Application layer",
    money: "1 ETH",
    data: "25/06/2022 8:00am",
  },
  {
    token: "Environment friendly",
    money: "1 ETH",
    data: "25/06/2022 8:00am",
  },
];
export default function HistoryTable() {
  return (
    <Box>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>
                <Box className="displayStart">
                  <img
                    src="images/bitcoin.png"
                    alt="image"
                    style={{ marginRight: "6px", width: "17px" }}
                  />
                  Bitcoin
                </Box>
              </TableCell>
              <TableCell style={{ textAlign: "right" }}>
                {" "}
                <Box className="displayStart">
                  <img
                    src="images/ethereum.png"
                    alt="image"
                    width="30px"
                    style={{ marginRight: "6px", width: "17px" }}
                  />
                  Ethereum
                </Box>
              </TableCell>
              <TableCell>
                {" "}
                <Box className="displayStart">
                  <img
                    src="images/ripple.png"
                    alt="image"
                    width="30px"
                    style={{ marginRight: "6px", width: "17px" }}
                  />
                  Ripple
                </Box>
              </TableCell>
              <TableCell>
                {" "}
                <Box className="displayStart">
                  <img
                    src="images/fearo.png"
                    alt="image"
                    width="30px"
                    style={{ marginRight: "6px", width: "17px" }}
                  />
                  Fieres
                </Box>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {/* {TableData.map((data, i) => ( */}
            <TableRow>
              <TableCell>Decentralised</TableCell>
              <TableCell>
                <HiOutlineCheckCircle className="greencheckBox" />
              </TableCell>
              <TableCell>
                <HiOutlineCheckCircle className="greencheckBox" />
              </TableCell>
              <TableCell>
                <AiOutlineCloseCircle className="redcheckBox" />
              </TableCell>
              <TableCell>
                <HiOutlineCheckCircle className="greencheckBox" />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Scalability</TableCell>
              <TableCell>
                <AiOutlineCloseCircle className="redcheckBox" />
              </TableCell>
              <TableCell>
                <AiOutlineCloseCircle className="redcheckBox" />
              </TableCell>
              <TableCell>
                <AiOutlineCloseCircle className="redcheckBox" />
              </TableCell>
              <TableCell>
                <HiOutlineCheckCircle className="greencheckBox" />
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>Secure</TableCell>
              <TableCell>
                <HiOutlineCheckCircle className="greencheckBox" />
              </TableCell>
              <TableCell>
                <HiOutlineCheckCircle className="greencheckBox" />
              </TableCell>
              <TableCell>
                <HiOutlineCheckCircle className="greencheckBox" />
              </TableCell>
              <TableCell>
                <HiOutlineCheckCircle className="greencheckBox" />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Speed</TableCell>
              <TableCell>
                <Typography varinat="body2" color="primary">
                  {" "}
                  4.6tps
                </Typography>

                <BorderLinearProgress variant="determinate" value={20} />
              </TableCell>
              <TableCell>
                <Typography varinat="body2" color="primary">
                  {" "}
                  20tps
                </Typography>

                <BorderLinearProgress variant="determinate" value={30} />
              </TableCell>
              <TableCell>
                <Typography varinat="body2" color="primary">
                  {" "}
                  1000tps
                </Typography>

                <BorderLinearProgress variant="determinate" value={50} />
              </TableCell>
              <TableCell>
                <Typography varinat="body2" color="primary">
                  {" "}
                  3500tps
                </Typography>

                <BorderLinearProgress variant="determinate" value={100} />
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>Transaction fees</TableCell>
              <TableCell>
                <Typography varinat="body2" className="redText">
                  {" "}
                  High
                </Typography>
              </TableCell>
              <TableCell>
                <Typography varinat="body2" className="redText">
                  {" "}
                  High
                </Typography>
              </TableCell>
              <TableCell>
                <Typography varinat="body2" className="greenText">
                  {" "}
                  Low
                </Typography>
              </TableCell>
              <TableCell>
                <Typography varinat="body2" className="greenText">
                  {" "}
                  Very Low
                </Typography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>Storage</TableCell>
              <TableCell>
                <Typography varinat="body2" color="primary">
                  {" "}
                  DLT
                </Typography>
              </TableCell>
              <TableCell>
                <Typography varinat="body2" color="primary">
                  {" "}
                  DLT
                </Typography>
              </TableCell>
              <TableCell>
                <Typography varinat="body2" color="primary">
                  {" "}
                  DLT
                </Typography>
              </TableCell>
              <TableCell>
                <Typography varinat="body2" color="primary">
                  {" "}
                  DLT
                </Typography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>Consensus</TableCell>
              <TableCell>
                <Typography varinat="body2" color="primary">
                  {" "}
                  DLT
                </Typography>
              </TableCell>
              <TableCell>
                <Typography varinat="body2" color="primary">
                  {" "}
                  DLT
                </Typography>
              </TableCell>
              <TableCell>
                <Typography varinat="body2" color="primary">
                  {" "}
                  DLT
                </Typography>
              </TableCell>
              <TableCell>
                <Typography varinat="body2" color="primary">
                  {" "}
                  DLT
                </Typography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>Application layer</TableCell>
              <TableCell>
                <AiOutlineCloseCircle className="redcheckBox" />
              </TableCell>
              <TableCell>
                <HiOutlineCheckCircle className="greencheckBox" />
              </TableCell>
              <TableCell>
                <AiOutlineCloseCircle className="redcheckBox" />
              </TableCell>
              <TableCell>
                <HiOutlineCheckCircle className="greencheckBox" />
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>Environment friendly</TableCell>
              <TableCell>
                <AiOutlineCloseCircle className="redcheckBox" />
              </TableCell>
              <TableCell>
                <AiOutlineCloseCircle className="redcheckBox" />
              </TableCell>
              <TableCell>
                <HiOutlineCheckCircle className="greencheckBox" />
              </TableCell>
              <TableCell>
                <HiOutlineCheckCircle className="greencheckBox" />
              </TableCell>
            </TableRow>
            {/* ))} */}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
